export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref14006.40b89ddc.jpg";